import { ApplicationConfigService } from '@ispm/navigation/services/applicationConfig.service';
import { NavigationBarAppLauncherComponent } from './components/navigationBarAppLauncher/navigationBarAppLauncher.component';
import { NavigationBarComponent } from './components/navigationBar/navigationBar.component';
import { NavigationBarItemComponent } from './components/navigationBarItem/navigationBarItem.component';
import { NavigationConfigService } from '@ispm/navigation/services/navigationConfig.service';
import { NavigationService } from './services/navigation.service';
import { NodePanelConfigurationService } from '@ispm-client/modules/bpmn-modeler/service/node-panel-configuration.service';
import { DisclaimerViewerComponent } from '../disclaimer-viewer/components/disclaimer-viewer.component';
import { InfoMenuComponent } from '../menu/components/info-menu/info-menu.component';
import { CaseSearchComponent } from '../components/case-search/case-search.component';
import { SearchResultTableComponent } from "@ispm/dashboard/components/search-result-table/search-result-table.component";

export const COMPONENTS = [NavigationBarComponent , NavigationBarItemComponent, NavigationBarAppLauncherComponent,
    DisclaimerViewerComponent,InfoMenuComponent,
    CaseSearchComponent,
    SearchResultTableComponent
];
export const COMPONENTS_EXPORTS = [NavigationBarComponent,
    DisclaimerViewerComponent,InfoMenuComponent,
    CaseSearchComponent,
    SearchResultTableComponent];
export const SERVICES = [NavigationService, NavigationConfigService, ApplicationConfigService, NodePanelConfigurationService];
